/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/media-has-caption */
import { FC, useState } from 'react'
import { Avatar, Button, Carousel } from 'rsuite'
import { FaHome, FaInfoCircle, FaPhoneAlt } from 'react-icons/fa'
import { MdNotifications, MdClose, MdApps } from 'react-icons/md'
import './advertisemnetPreview.scss'
import { Advertisement } from 'pages/template/types'

interface AdvertisementTemplateProps {
  open: boolean;
  onClose: () => void;
  className?: string;
  isAdvertisement?: boolean;
  isCompaignAdvertisement?: boolean;
  selectedAdvertisementTemplate?: Advertisement;
}

const AdvertisementTemplateView: FC<AdvertisementTemplateProps> = ({
  open,
  onClose,
  className,
  isAdvertisement,
  selectedAdvertisementTemplate,
  isCompaignAdvertisement
}) => {
  const [activeIndex, setActiveIndex] = useState(0)

  if (!open) return null

  const hasImage = !!selectedAdvertisementTemplate?.image
  const hasVideo = !!selectedAdvertisementTemplate?.video

  const handleSelect = (index: number) => {
    setActiveIndex(index)
  }

  if (isCompaignAdvertisement) {
    return (
      <div className={`isCompaignAdvertisement ${className}`}>
        <div className="content-header">
          <div className="content-info">
            <Avatar circle src="https://via.placeholder.com/40" />
            <div className="content-title">
              <h5 className="content-name">Hello User!</h5>
            </div>
          </div>
          <div className="actions">
            <Button disabled>
              <MdNotifications />
            </Button>
            <Button className="closeIcon" onClick={onClose}>
              <MdClose className="closeIcon" />
            </Button>
          </div>
        </div>

        <div className="content-list">
          {hasImage && hasVideo ? (
            <Carousel
              autoplay
              className="ad-carousel"
              autoplayInterval={15000}
              activeIndex={activeIndex}
              onSelect={handleSelect}
            >
              <div className="ad-container">
                <img
                  src={selectedAdvertisementTemplate.image}
                  alt="Advertisement"
                  className="ad-img"
                />
                <div className="ad-overlay">
                  <p className="ad-name">
                    {selectedAdvertisementTemplate.name}
                  </p>
                  <p className="ad-text">
                    {selectedAdvertisementTemplate?.message}
                  </p>
                </div>
              </div>
              <div className="ad-container">
                <video controls className="ad-video" autoPlay>
                  <source
                    src={selectedAdvertisementTemplate.video}
                    type="video/mp4"
                  />
                  <track
                    src="captions.vtt"
                    kind="subtitles"
                    srcLang="en"
                    label="English"
                  />
                  Your browser does not support the video tag.
                </video>
                <div className="ad-overlay">
                  <p className="ad-name">
                    {selectedAdvertisementTemplate.name}
                  </p>
                  <p className="ad-text">
                    {selectedAdvertisementTemplate.message}
                  </p>
                </div>
              </div>
            </Carousel>
          ) : hasImage ? (
            <div className="ad-container">
              <img
                src={selectedAdvertisementTemplate.image}
                alt="Advertisement"
                className="ad-img"
              />
              <div className="ad-overlay">
                <p className="ad-name">{selectedAdvertisementTemplate.name}</p>
                <p className="ad-text">
                  {selectedAdvertisementTemplate.message}
                </p>
              </div>
            </div>
          ) : hasVideo ? (
            <div className="ad-container">
              <video controls className="ad-video" autoPlay>
                <source
                  src={selectedAdvertisementTemplate.video}
                  type="video/mp4"
                />
                <track
                  src="captions.vtt"
                  kind="subtitles"
                  srcLang="en"
                  label="English"
                />
                Your browser does not support the video tag.
              </video>
              <div className="ad-overlay">
                <p className="ad-text">
                  {selectedAdvertisementTemplate.message}
                </p>
              </div>
            </div>
          ) : (
            <p className="no-media">Template is not available.</p>
          )}
        </div>

        <div className="message-footer">
          <Button appearance="subtle" className="footer-button" disabled>
            <FaHome />
          </Button>
          <Button appearance="subtle" className="footer-button" disabled>
            <FaInfoCircle />
          </Button>
          <Button appearance="subtle" className="footer-button" disabled>
            <FaPhoneAlt />
          </Button>
          <Button appearance="subtle" className="footer-button" disabled>
            <MdApps />
          </Button>
        </div>
      </div>
    )
  }

  return !isAdvertisement ? (
    <div className={`Advertisement-container ${className}`}>
      <div className="content-header">
        <div className="content-info">
          <Avatar circle src="https://via.placeholder.com/40" />
          <div className="content-title">
            <h5 className="content-name">Hello User!</h5>
          </div>
        </div>
        <div className="actions">
          <Button disabled>
            <MdNotifications />
          </Button>
          <Button className="closeIcon" onClick={onClose}>
            <MdClose className="closeIcon" />
          </Button>
        </div>
      </div>

      <div className="content-list">
        {hasImage && hasVideo ? (
          <Carousel
            autoplay
            className="ad-carousel"
            autoplayInterval={15000}
            activeIndex={activeIndex}
            onSelect={handleSelect}
          >
            <div className="ad-container">
              <img
                src={selectedAdvertisementTemplate.image}
                alt="Advertisement"
                className="ad-img"
              />
              <div className="ad-overlay">
                <p className="ad-name">{selectedAdvertisementTemplate.name}</p>
                <p className="ad-text">
                  {selectedAdvertisementTemplate?.message}
                </p>
              </div>
            </div>
            <div className="ad-container">
              <video controls className="ad-video" autoPlay>
                <source
                  src={selectedAdvertisementTemplate.video}
                  type="video/mp4"
                />
                <track
                  src="captions.vtt"
                  kind="subtitles"
                  srcLang="en"
                  label="English"
                />
                Your browser does not support the video tag.
              </video>
              <div className="ad-overlay">
                <p className="ad-name">{selectedAdvertisementTemplate.name}</p>
                <p className="ad-text">
                  {selectedAdvertisementTemplate.message}
                </p>
              </div>
            </div>
          </Carousel>
        ) : hasImage ? (
          <div className="ad-container">
            <img
              src={selectedAdvertisementTemplate.image}
              alt="Advertisement"
              className="ad-img"
            />
            <div className="ad-overlay">
              <p className="ad-name">{selectedAdvertisementTemplate.name}</p>
              <p className="ad-text">{selectedAdvertisementTemplate.message}</p>
            </div>
          </div>
        ) : hasVideo ? (
          <div className="ad-container">
            <video controls className="ad-video" autoPlay>
              <source
                src={selectedAdvertisementTemplate.video}
                type="video/mp4"
              />
              <track
                src="captions.vtt"
                kind="subtitles"
                srcLang="en"
                label="English"
              />
              Your browser does not support the video tag.
            </video>
            <div className="ad-overlay">
              <p className="ad-text">{selectedAdvertisementTemplate.message}</p>
            </div>
          </div>
        ) : (
          <p className="no-media">Template is not available.</p>
        )}
      </div>

      <div className="message-footer">
        <Button appearance="subtle" className="footer-button" disabled>
          <FaHome />
        </Button>
        <Button appearance="subtle" className="footer-button" disabled>
          <FaInfoCircle />
        </Button>
        <Button appearance="subtle" className="footer-button" disabled>
          <FaPhoneAlt />
        </Button>
        <Button appearance="subtle" className="footer-button" disabled>
          <MdApps />
        </Button>
      </div>
    </div>
  ) : (
    <div className={`isAdvertisement-container ${className}`}>
      <div className="content-header">
        <div className="content-info">
          <Avatar circle src="https://via.placeholder.com/40" />
          <div className="content-title">
            <h5 className="content-name">Hello User!</h5>
          </div>
        </div>
        <div className="actions">
          <Button disabled>
            <MdNotifications />
          </Button>
          <Button className="closeIcon" onClick={onClose}>
            <MdClose className="closeIcon" />
          </Button>
        </div>
      </div>

      <div className="content-list">
        {hasImage && hasVideo ? (
          <Carousel
            className="ad-carousel"
            activeIndex={activeIndex}
            onSelect={handleSelect}
            autoplay
            autoplayInterval={15000}
          >
            <div className="ad-container">
              <img
                src={selectedAdvertisementTemplate.image}
                alt="Advertisement"
                className="ad-img"
              />
              <div className="ad-overlay">
                {/* <p className="ad-name">{selectedTemplate.name}</p> */}
                <p className="ad-text">
                  {selectedAdvertisementTemplate.message}
                </p>
              </div>
            </div>
            <div className="ad-container">
              <video controls className="ad-video" autoPlay>
                <source
                  src={selectedAdvertisementTemplate.video}
                  type="video/mp4"
                />
                <track
                  src="captions.vtt"
                  kind="subtitles"
                  srcLang="en"
                  label="English"
                />
                Your browser does not support the video tag.
              </video>
              <div className="ad-overlay">
                <p className="ad-text">
                  {selectedAdvertisementTemplate.message}
                </p>
              </div>
            </div>
          </Carousel>
        ) : hasImage ? (
          <div className="ad-container">
            <img
              src={selectedAdvertisementTemplate.image}
              alt="Advertisement"
              className="ad-img"
            />
            <div className="ad-overlay">
              <p className="ad-text">{selectedAdvertisementTemplate.message}</p>
            </div>
          </div>
        ) : hasVideo ? (
          <div className="ad-container">
            <video controls className="ad-video" autoPlay>
              <source
                src={selectedAdvertisementTemplate.video}
                type="video/mp4"
              />
              <track
                src="captions.vtt"
                kind="subtitles"
                srcLang="en"
                label="English"
              />
              Your browser does not support the video tag.
            </video>
            <div className="ad-overlay">
              <p className="ad-text">{selectedAdvertisementTemplate.message}</p>
            </div>
          </div>
        ) : (
          <p className="no-media-message">
            {selectedAdvertisementTemplate?.message}
          </p>
        )}
      </div>

      <div className="message-footer">
        <Button appearance="subtle" className="footer-button" disabled>
          <FaHome />
        </Button>
        <Button appearance="subtle" className="footer-button" disabled>
          <FaInfoCircle />
        </Button>
        <Button appearance="subtle" className="footer-button" disabled>
          <FaPhoneAlt />
        </Button>
        <Button appearance="subtle" className="footer-button" disabled>
          <MdApps />
        </Button>
      </div>
    </div>
  )
}

export default AdvertisementTemplateView
